import { render, staticRenderFns } from "./ImportResultRh.vue?vue&type=template&id=ddfc1da4&scoped=true"
import script from "./ImportResultRh.vue?vue&type=script&lang=js"
export * from "./ImportResultRh.vue?vue&type=script&lang=js"
import style0 from "./ImportResultRh.vue?vue&type=style&index=0&id=ddfc1da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfc1da4",
  null
  
)

export default component.exports